import { jsx, jsxs } from "react/jsx-runtime";
import { Check as CheckIcon } from "@tamagui/lucide-icons";
import { Checkbox, Label, XStack, YStack } from "tamagui";
function CheckboxDemo() {
  return /* @__PURE__ */ jsxs(YStack, { width: 300, alignItems: "center", space: "$2", children: [
    /* @__PURE__ */ jsx(CheckboxWithLabel, { size: "$3" }),
    /* @__PURE__ */ jsx(CheckboxWithLabel, { size: "$4", defaultChecked: true }),
    /* @__PURE__ */ jsx(CheckboxWithLabel, { size: "$5" })
  ] });
}
function CheckboxWithLabel(props) {
  const id = `checkbox-${props.size.toString().slice(1)}`;
  return /* @__PURE__ */ jsxs(XStack, { width: 300, alignItems: "center", space: "$4", children: [
    /* @__PURE__ */ jsx(Checkbox, { id, size: props.size, defaultChecked: props.defaultChecked, children: /* @__PURE__ */ jsx(Checkbox.Indicator, { children: /* @__PURE__ */ jsx(CheckIcon, {}) }) }),
    /* @__PURE__ */ jsx(Label, { size: props.size, htmlFor: id, children: "Accept terms and conditions" })
  ] });
}
export {
  CheckboxDemo,
  CheckboxWithLabel
};
//# sourceMappingURL=CheckboxDemo.js.map
